import Mobile from './mobile';
import Tablet from './tablet';
import Desktop from './desktop';

export { Mobile, Tablet, Desktop };
